type BondNaturalTenant = {
  main_tenant_gender?: string;
  main_tenant_marital_status?: string;
  main_tenant_birth_date?: string | Date;
  main_tenant_name?: string;
  main_tenant_cpf?: string;
};

export type BondInsuranceLike = {
  id?: string;
  lenderInsuranceId?: string;
  lender_insurance_id?: string;
  natural_tenant?: BondNaturalTenant;
  naturalTenant?: BondNaturalTenant;
  legal_tenant?: { company?: string };
  legalTenant?: { company?: string };
  property?: { street?: string; number?: string };
};

export function getBondNaturalTenant(
  bondInsurance?: BondInsuranceLike | null
): BondNaturalTenant | undefined {
  return bondInsurance?.natural_tenant || bondInsurance?.naturalTenant;
}

export function getBondTenantGender(
  bondInsurance?: BondInsuranceLike | null
): string | undefined {
  const gender = getBondNaturalTenant(bondInsurance)?.main_tenant_gender;
  return gender?.trim() || undefined;
}

export function getBondTenantMaritalStatus(
  bondInsurance?: BondInsuranceLike | null
): string | undefined {
  const maritalStatus = getBondNaturalTenant(bondInsurance)?.main_tenant_marital_status;
  return maritalStatus?.trim() || undefined;
}

export function getBondTenantBirthDate(
  bondInsurance?: BondInsuranceLike | null
): string | undefined {
  const rawBirthDate = getBondNaturalTenant(bondInsurance)?.main_tenant_birth_date;
  if (!rawBirthDate) return undefined;

  if (rawBirthDate instanceof Date) {
    return rawBirthDate.toISOString().split('T')[0];
  }

  const birthDate = String(rawBirthDate).trim();
  return birthDate || undefined;
}

export function isBondTenantProfileComplete(
  bondInsurance?: BondInsuranceLike | null
): boolean {
  return Boolean(
    getBondTenantGender(bondInsurance) &&
    getBondTenantMaritalStatus(bondInsurance) &&
    getBondTenantBirthDate(bondInsurance)
  );
}

export function getMissingBondTenantProfileFields(
  bondInsurance?: BondInsuranceLike | null
): string[] {
  const missing: string[] = [];

  if (!getBondTenantGender(bondInsurance)) {
    missing.push('sexo');
  }
  if (!getBondTenantMaritalStatus(bondInsurance)) {
    missing.push('estado civil');
  }
  if (!getBondTenantBirthDate(bondInsurance)) {
    missing.push('data de nascimento');
  }

  return missing;
}
